import React from 'react';
import { Skeleton } from 'antd';
import { PageHeader } from '@ant-design/pro-layout';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetManyWarehouseTasks } from 'api/warehouse-task/use-get-many-warehouses-tasks';
import { usePageReset } from 'shared/hooks/use-page-reset';
import { usePaginationParams } from 'shared/hooks/use-pagination-params';
import { useWhTaskFiltersStore } from 'shared/stores/use-wh-task-filters';
import { Pagination } from 'components/pagination';
import { WhTaskCreate } from 'components/wh-tasks/wh-task-create';
import { WhTaskFilter } from 'components/wh-tasks/wh-task-filter';
import { WhTasksList } from 'components/wh-tasks/wh-tasks-list';

export const WhTasksListPage: React.FC = () => {
  const { page, limit, handlePageChange } = usePaginationParams();
  const { filters, search } = useWhTaskFiltersStore();
  const { data: tasks, isLoading, isPreviousData } = useGetManyWarehouseTasks({ page, limit, filters, search });

  usePageReset([filters, search]);

  const header = <PageHeader title={<WhTaskFilter />} extra={[<WhTaskCreate key='wh-task-create' />]} />;

  return (
    <DefaultPageLayout header={header}>
      <Skeleton loading={isLoading}>
        <WhTasksList tasks={tasks?.data ?? []} isLoading={isPreviousData} />
        <Pagination
          total={tasks?.pagination?.total}
          page={tasks?.pagination?.currentPage}
          limit={tasks?.pagination?.limit}
          onChange={handlePageChange}
        />
      </Skeleton>
    </DefaultPageLayout>
  );
};
